<template>
  <div>
    <div class="container" v-if="fill_info == ''">
      <div class="row">
        <div class="col-xs-12 col-md-3">
          <div class="panels">
            <DocumentUploader ref="igazolasfeltolto"/>
            <PointPanel ref="pontszam"/>
          </div>
        </div>

        <!-- Űrlap -->
        <div class="col-xs-12 col-md-9">
          <div class="form-title">Rendszeres szociális támogatás és költségtérítés mérséklés</div>

          <!-- ------------------------------ Hallgató Adatok ------------------------------ -->

          <HallgatoAdatok v-on:onReady="(hallgato,hallgato_szakok,szocpontParameterek) => {this.save_enabled = true;this.hallgato = hallgato;this.hallgato_szakok = hallgato_szakok; this.szocpontParameterek = szocpontParameterek; this.tavolsagpontKalk(); this.kalkJovedelemTipusok(); this.kalkJovedelemOsszeg(); this.jovedelmekPontKalkulacio(); }"></HallgatoAdatok>


          <!-- ------------------------------ Szülői adatok ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>Szülői adatok</span>
          </h5>
          <div class="row">
            <div class="col-md-6">
              <inputbox :tooltipDescription="getTooltipDescriptionByKey('Anya_fogl')" :errors="errors" iconclass="fa fa-pencil" id="Anya_Fogl" label="Édesanyja foglalkozása, munkahelye" name="Anya_Fogl" v-model="form.Anya_Fogl"/>
            </div>
            <div class="col-md-6">
              <inputbox :tooltipDescription="getTooltipDescriptionByKey('Apa_fogl')" :errors="errors" iconclass="fa fa-pencil" id="Apa_Fogl" label="Édesapja foglalkozása, munkahelye" name="Apa_Fogl" v-model="form.Apa_Fogl"/>
            </div>
          </div>

          <!-- ------------------------------ Igényelt támogatások ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>Igényelt támogatások</span>
          </h5>

          <div class="form-group">
            <label class="form-label">Igényelt támogatások</label>
            <div class="form-checkbox-wrapper" v-for="(option, i) in tamogatasok">
              <input :id="'tamogatas_'+i" :name="'tamogatas_'+i" type="checkbox" :value="option.value" v-model="form.tamogatasok"/>
              <label :for="'tamogatas_'+i">
                <div class="icon"></div>
                {{ option.text }}
                <Tooltip :description="getTooltipDescriptionByKey(option.value)"/>
              </label>
            </div>
            <template v-for="(error, i) in errors">
              <div v-if="error.id == 'tamogatasok'" class="form-error">{{ error.msg }}</div>
            </template>
          </div>

          <!-- ------------------------------ Költségtérítés mérséklés ------------------------------ -->

          <div v-show="form.tamogatasok.indexOf('Kolts_Csokk') > -1">
            <h5 class="form-block-title-layout-tab">
              <span>Költségtérítés mérséklés</span>
            </h5>

            <div class="form-group" style="padding-bottom: 0px">
              <div class="form-checkbox-wrapper">
                <input v-on:click="fileBoxChange('TMDK', 'TMDK tevékenység', '', $event, 'TMDK')" id="TMDK" name="TMDK" type="checkbox" value="1" v-model="form.TMDK"/>
                <label for="TMDK">
                  <div class="icon"></div>
                  TMDK tevékenység az elmúlt egy évben
                  <Tooltip :description="getTooltipDescriptionByKey('TMDK')"/>
                </label>
              </div>
            </div>
            <textareabox :errors="errors" cstyle="min-height: 100px" iconclass="fa fa-pencil" :autogrow="true" maxlength="1000" v-show="form.TMDK" id="TMDKSzoveg" label="" name="TMDKSzoveg" v-model="form.TMDKSzoveg"/>

            <div class="form-group" style="padding-bottom: 0px">
              <div class="form-checkbox-wrapper">
                <input v-on:click="fileBoxChange('hallgSzervTev', 'Hallgatói szervezetben végzett tevékenység az elmúlt egy évben', '', $event, 'hallgSzervTev')" id="HallgSzervTev" name="HallgSzervTev" type="checkbox" value="1" v-model="form.HallgSzervTev"/>
                <label for="HallgSzervTev">
                  <div class="icon"></div>
                  Hallgatói szervezetben végzett tevékenység az elmúlt egy évben
                  <Tooltip :description="getTooltipDescriptionByKey('hallgSzervTev')"/>
                </label>
              </div>
            </div>
            <textareabox :errors="errors" cstyle="min-height: 100px" v-show="form.HallgSzervTev" maxlength="1000" :autogrow="true" iconclass="fa fa-pencil" id="HallgSzervTevSzoveg" label="" name="HallgSzervTevSzoveg" v-model="form.HallgSzervTevSzoveg"/>

            <div class="form-group" style="padding-bottom: 0px">
              <div class="form-checkbox-wrapper">
                <input v-on:click="fileBoxChange('EgyebTev', 'Egyéb tevékenység', '', $event, 'EgyebTev')" id="EgyebTev" name="EgyebTev" type="checkbox" value="1" v-model="form.EgyebTev"/>
                <label for="EgyebTev">
                  <div class="icon"></div>
                  Egyéb
                  <Tooltip :description="getTooltipDescriptionByKey('EgyebTev')"/>
                </label>
              </div>
            </div>
            <textareabox :errors="errors" cstyle="min-height: 100px" v-show="form.EgyebTev" maxlength="1000" :autogrow="true" iconclass="fa fa-pencil" id="EgyebTevSzoveg" label="" name="EgyebTevSzoveg" v-model="form.EgyebTevSzoveg"/>
          </div>

          <!-- ------------------------------ Családi állapot és fogyatékosság ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>Családi állapot és fogyatékosság</span>
          </h5>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <div v-if="i >=0 && i <= 5" :class="{disabled:option.disabled > 0}" class="form-checkbox-wrapper" v-for="(option, i) in csaladi_allapot_fogyatekossag">
                  <input :disabled="option.disabled > 0" ref="'csaladi_allapot_fogyatekossag_'+option.value" v-on:change="csaladiAllapotFogyatekossagChange('csaladi_allapot_fogyatekossag_'+option.value, option.text, '', '', option.point, $event, option.value)" :id="'csaladi_allapot_fogyatekossag_'+option.value" :name="'csaladi_allapot_fogyatekossag_'+option.value" type="checkbox" :value="option.value" v-model="form.csaladi_allapot_fogyatekossag"/>
                  <label :for="'csaladi_allapot_fogyatekossag_'+option.value">
                    <div class="icon"></div>
                    {{ option.text }}
                    <Tooltip :description="getTooltipDescriptionByKey(option.value)"/>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <div v-if="i >=6" :class="{disabled:option.disabled > 0}" class="form-checkbox-wrapper" v-for="(option, i) in csaladi_allapot_fogyatekossag">
                  <input :disabled="option.disabled > 0" ref="'csaladi_allapot_fogyatekossag_'+option.value" v-on:change="csaladiAllapotFogyatekossagChange('csaladi_allapot_fogyatekossag_'+option.value, option.text, '', '', option.point, $event, option.value)" :id="'csaladi_allapot_fogyatekossag_'+option.value" :name="'csaladi_allapot_fogyatekossag_'+option.value" type="checkbox" :value="option.value" v-model="form.csaladi_allapot_fogyatekossag"/>
                  <label :for="'csaladi_allapot_fogyatekossag_'+option.value">
                    <div class="icon"></div>
                    {{ option.text }}
                    <Tooltip :description="getTooltipDescriptionByKey(option.value)"/>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <template v-for="(error, i) in errors">
            <div v-if="error.id == 'csaladi_allapot_fogyatekossag'" class="form-error">{{ error.msg }}</div>
          </template>

          <!-- ------------------------------ Betegség ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>Betegség</span>
          </h5>
          <div class="form-info">
            A pályázó és/vagy vele egy háztartásban élő személy, aki fogyatékkal él, tartós betegségben szenved vagy orvosi kezelés alatt áll.
          </div>
          <table v-if="form.betegsegek.length > 0" class="list-table">
            <tr>
              <th>Kód</th>
              <th>Megnevezés</th>
              <th>Pályázó betegsége</th>
              <th>Családtag neve</th>
              <th>Rokonsági fok</th>
              <th></th>
            </tr>
            <tr v-for="(betegseg, i) in form.betegsegek">
              <td style="vertical-align: top">{{ betegseg.BNOKod }}</td>
              <td style="vertical-align: top">{{ betegseg.BetegsegNeve }}</td>
              <td style="vertical-align: top">
                <div class="form-checkbox-wrapper">
                  <!--<input :id="'PalyazoBetegsege_'+i" :name="'PalyazoBetegsege_'+i" type="checkbox" value="1" v-model="betegseg.PalyazoBetegsege"/>-->
                  <label :for="'PalyazoBetegsege_'+i">
                    <!--<div class="icon"></div>
                    Igen-->
                    {{betegseg.PalyazoBetegsege ? 'Igen' : 'Nem'}}
                  </label>
                </div>
              </td>
              <td style="vertical-align: top">
                <inputbox :errors="errors" v-show="!betegseg.PalyazoBetegsege" iconclass="fa fa-pencil" regexp_filter="[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+" :id="'BetegsegCsaladtagNeve_'+i" label="" :name="'BetegsegCsaladtagNeve_'+i" v-model="betegseg.CsaladtagNeve"/>
              </td>
              <td style="vertical-align: top">
                <inputbox :errors="errors" v-show="!betegseg.PalyazoBetegsege" iconclass="fa fa-pencil" regexp_filter="[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+" :id="'BetegsegCsaladtagRokonsagiFoka_'+i" label="" :name="'BetegsegCsaladtagRokonsagiFoka_'+i" v-model="betegseg.CsaladtagRokonsagiFoka"/>
              </td>
              <td style="vertical-align: top">
                <button v-on:click="betegsegTorles(betegseg.id)" type="button" class="button only-icon"><i class="fa fa-trash-o"></i></button>
              </td>
            </tr>
          </table>

          <select2ajax url="/hatar/betegseg_kereses" id="uj_betegseg_BNOKod" label="Betegség kódja / megnevezése" name="uj_betegseg_BNOKod" v-model="betegsegek"/>

          <div class="form-group">
            <div class="form-label">
              Pályázó betegsége
            </div>
            <div class="form-checkbox-wrapper">
              <input id="uj_betegseg_PalyazoBetegsege" name="uj_betegseg_PalyazoBetegsege" type="checkbox" value="1" v-model="uj_betegseg.PalyazoBetegsege"/>
              <label for="uj_betegseg_PalyazoBetegsege">
                <div class="icon"></div>
                Igen
              </label>
            </div>
          </div>

          <inputbox v-show="!uj_betegseg.PalyazoBetegsege" iconclass="fa fa-pencil" regexp_filter="[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+" id="uj_betegseg_CsaladtagNeve" label="Családtag neve" name="uj_betegseg_CsaladtagNeve" v-model="uj_betegseg.CsaladtagNeve"/>
          <inputbox v-show="!uj_betegseg.PalyazoBetegsege" iconclass="fa fa-pencil" regexp_filter="[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+" id="uj_betegseg_CsaladtagRokonsagiFoka" label="Családtag rokonsági foka" name="uj_betegseg_CsaladtagRokonsagiFoka" v-model="uj_betegseg.CsaladtagRokonsagiFoka"/>


          <div class="form-group">
            <button v-on:click="betegsegHozzaad" type="button" name="kuld" class="button v3">Új betegség hozzáadása</button>
          </div>

          <h5 class="form-block-title-layout-tab">
            <span>Pályázó szembetegsége</span>
          </h5>

          <div class="info-box warning">
            <span class="highlight">Figyelem!</span> A dioptria értékeket csak akkor vesszük figyelembe, ha a "Betegségek" blokkban felvette saját betegségként szembetegségét.
          </div>

          <div class="row">
            <div class="col-md-6">
              <inputbox v-on:onchange="szembetegsegPontKalk" iconclass="fa fa-pencil" regexp_filter="[0-9]{1,2}[.]{0,1}[0-9]{0,2}" id="BalDioptria" label="Bal dioptria" name="BalDioptria" v-model="form.BalDioptria"/>
            </div>
            <div class="col-md-6">
              <inputbox v-on:onchange="szembetegsegPontKalk" iconclass="fa fa-pencil" regexp_filter="[0-9]{1,2}[.]{0,1}[0-9]{0,2}" id="JobbDioptria" label="Jobb dioptria" name="JobbDioptria" v-model="form.JobbDioptria"/>
            </div>
          </div>

          <textareabox :errors="errors" cstyle="min-height: 100px" maxlength="1000" :autogrow="true" iconclass="fa fa-pencil" id="Palyazo_Betegsege" label="Megjegyzés" name="Palyazo_Betegsege" v-model="form.Palyazo_Betegsege"/>

          <!-- ------------------------------ Nettó jövedelem ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>
              Nettó jövedelem
            </span>
          </h5>
          <div class="form-info">
            A pályázóval közös háztartásban élők előző havi nettó jövedelme (forintban).
          </div>
          <table class="list-table">
            <tr>
              <th>Pályázó</th>
              <th>Név</th>
              <th>Rokonsági fok</th>
              <th>Típus</th>
              <th>Jövedelem</th>
              <th style="width: 51px"></th>
            </tr>
            <tr v-if="form.jovedelmek.length > 0" v-for="(jovedelem, i) in form.jovedelmek">
              <td style="vertical-align: top">
                <div class="form-checkbox-wrapper">
                  <input v-on:change="jovedelemPalyazoChange(i)" :id="'jovedelem_palyazo_'+i" :name="'jovedelem_palyazo_'+i" type="checkbox" value="1" v-model="jovedelem.Palyazo"/>
                  <label :for="'jovedelem_palyazo_'+i">
                    <div class="icon"></div>
                  </label>
                </div>
              </td>
              <td style="vertical-align: top">
                <inputbox v-on:onkeyup="jovedelemUploaderBlokkModositas(jovedelem.id)" :errors="errors" iconclass="fa fa-pencil" :id="'jovedelem_nev_'+i" label="" :name="'jovedelem_nev_'+i" v-model="jovedelem.Nev"/>
              </td>
              <td style="vertical-align: top">
                <inputbox :errors="errors" iconclass="fa fa-pencil" :id="'jovedelem_rokonsagi_fok_'+i" label="" :name="'jovedelem_rokonsagi_fok_'+i" v-model="jovedelem.Rokonsagi_Fok"/>
              </td>
              <td style="vertical-align: top">
                <div class="form-group">
                  <select v-on:change="() => { jovedelemUploaderBlokkModositas(jovedelem.id); kalkJovedelemTipusok(); jovedelmekPontKalkulacio(); }" class="form-control" :name="'jovedelem_tipus_'+i" :id="'jovedelem_tipus_'+i" v-model="jovedelem.Tipus">
                    <option v-for="(jt, i) in jovedelem_tipusok" :value="jt.value">{{ jt.text }}</option>
                  </select>
                </div>
              </td>
              <td style="vertical-align: top">
                <inputbox v-on:onkeyup="() => {jovedelmekPontKalkulacio(); kalkJovedelemOsszeg();}" :errors="errors" regexp_filter="[0-9]+" iconText="Ft" :id="'jovedelem_osszeg_'+i" label="" :name="'jovedelem_osszeg_'+i" v-model="jovedelem.Osszeg"/>
              </td>
              <td style="vertical-align: top">
                <button v-on:click="jovdelemTorles(jovedelem.id)" type="button" class="button only-icon"><i class="fa fa-trash-o"></i></button>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top">
                <div v-on:change="ujJovedelemPalyazoChange" class="form-checkbox-wrapper">
                  <input id="uj_jovedelem_palyazo" name="uj_jovedelem_palyazo" type="checkbox" value="1" v-model="uj_jovedelem.Palyazo"/>
                  <label for="uj_jovedelem_palyazo">
                    <div class="icon"></div>
                  </label>
                </div>
              </td>

              <td style="vertical-align: top">
                <inputbox regexp_filter="[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+" iconclass="fa fa-pencil" id="uj_jovedelem_nev" label="" name="uj_jovedelem_nev" v-model="uj_jovedelem.Nev"/>
              </td>
              <td style="vertical-align: top">
                <inputbox regexp_filter="[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+" iconclass="fa fa-pencil" id="uj_jovedelem_rokonsagi_fok" label="" name="uj_jovedelem_rokonsagi_fok" v-model="uj_jovedelem.Rokonsagi_Fok"/>
              </td>
              <td style="vertical-align: top">
                <div class="form-group">
                  <select class="form-control" name="uj_jovedelem_tipus" id="uj_jovedelem_tipus" v-model="uj_jovedelem.Tipus">
                    <option v-for="(jt, i) in jovedelem_tipusok" :value="jt.value">{{ jt.text }}</option>
                  </select>
                </div>
              </td>
              <td style="vertical-align: top">
                <inputbox :errors="errors" regexp_filter="[0-9]+" iconText="Ft" id="uj_jovedelem_osszeg" label="" name="uj_jovedelem_osszeg" v-model="uj_jovedelem.Osszeg"/>
              </td>
              <td style="vertical-align: top">
                <button v-on:click="jovedelemHozzaad" type="button" class="button v3 only-icon"><i class="fa fa-plus"></i></button>
              </td>
            </tr>
            <tr class="points">
              <td colspan="3"></td>
              <td style="vertical-align: top;">
                <div v-for="jt in jovedelem_tipusok_kalk" class="point-block">
                  <div class="point">
                    {{ jt.pont }}
                  </div>
                  <span>{{ jt.db }} x</span>&nbsp;{{ jt.cim }}
                </div>
              </td>
              <td style="vertical-align: top;">
                <div v-if="jovedelem_osszeg_kalk !=  0" class="point-block">
                  <div class="point">
                    {{ jovedelem_osszeg_pont }}
                  </div>
                  <span>{{ jovedelem_osszeg_kalk }} Ft</span>
                </div>
              </td>
              <td style="vertical-align: top;">
                <div v-if="jovedelem_osszpont != 0" class="point-block">
                  <div class="point dark">
                    {{ jovedelem_osszpont }}
                  </div>
                </div>
              </td>
            </tr>
          </table>

          <div class="info-box warning">
            A pályázat igazolások nélkül <span class="highlight">érvénytelennek</span> minősül.
          </div>

          <div class="form-group">
            <label class="form-label">Hallgatói nyilatkozat</label>
            <div class="form-scroll-block">A jelentkezési lapon szereplő személyes adatok kezelése az érintett önkéntes hozzájárulásán alapul, mely hozzájárulást az érintett a pályázati adatlap kitöltésével és annak aláírásával ad meg.<br><br>Az adatkezelők harmadik személy(ek) részére adattovábbítást nem végeznek.<br><br>Az érintett hozzájárulása indokolás nélkül bármikor visszavonható.<br><br>A kezelt adatokba betekintést kizárólag az adatkezelők ösztöndíj elnyerésére való jogosultság megállapításával, annak elbírálásával, valamint az ösztöndíj folyósításával összefüggő feladatokat ellátó munkatársa(i) nyerhet(nek) a fenti feladatok ellátásához szükséges ideig és mértékben. A jelentkezési lapon szereplő adatok a jelentkezés sikertelensége esetén az elbírálást követő 1 hónapig kezelhetőek.<br><br>Pozitív elbírálás esetén a Széchenyi István Egyetem az EFOP-3.6.1-16-2016-00017 pályázat keretében az ösztöndíjas hallgatóról megismert személyes adatokat az ösztöndíjszerződés lejáratát követő 8 évig jogosult kezelni.<br><br>Az érintett az adatkezelés teljes időtartama alatt élhet az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvényben biztosított jogával, (tájékoztatáshoz, helyesbítéshez, törléshez, zároláshoz, tiltakozáshoz való jog) továbbá jogsérelem esetén bírósághoz, valamint a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (1125 Budapest, Szilágyi Erzsébet fasor 22/c., tel.: 06-1-391-1400, honlap URL címe: http://naih.hu, elektronikus levelezési cím: ugyfelszolgalat@naih.hu ) is fordulhat.</div>
          </div>

          <div class="form-group">
            <div class="form-checkbox-wrapper">
              <input id="nyilatkozat" name="nyilatkozat" type="checkbox" value="1" v-model="form.nyilatkozat"/>
              <label for="nyilatkozat">
                <div class="icon"></div>
                Büntetőjogi felelősségem tudatában tudomásul veszem a fentieket
              </label>
            </div>
            <template v-for="(error, i) in errors">
              <div v-if="error.id == 'nyilatkozat'" class="form-error">{{ error.msg }}</div>
            </template>
          </div>

          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(0)" type="button" name="kuld" class="button" :disabled="!save_enabled">Mentés</button>
            <button v-on:click="save(1)" type="button" name="veglegesit" class="button" :disabled="!save_enabled">Véglegesít</button>
          </div>
        </div>

      </div>
    </div>
    <div class="container" v-show="fill_info != ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">Rendszeres szociális támogatás és költségtérítés mérséklés</div>
          <div class="article-text" v-html="fill_info"></div>
          <div v-if="urlap_letoltheto" style="padding-top: 20px"><button v-on:click="rendszeresSzocialisTamogatasPdf" type="button" class="button">Pályázat letöltése</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import HallgatoAdatok from './hatar_hallgato_adatok.vue';

export default {
  components: {
    HallgatoAdatok
  },

  data: function() {
    return {
      fill_info: '',
      save_enabled: false,
      errors: [],
      form: {
        nyilatkozat: false,
        Anya_Fogl: '',
        Apa_Fogl: '',
        tamogatasok: [],
        TMDK: false,
        TMDKSzoveg: '',
        HallgSzervTev: false,
        HallgSzervTevSzoveg: '',
        EgyebTev: false,
        EgyebTevSzoveg: '',
        csaladi_allapot_fogyatekossag: [],
        betegsegek: [],
        jovedelmek: [],
        BalDioptria: '',
        JobbDioptria: '',
        Palyazo_Betegsege: ''
      },
      hallgato: {},
      hallgato_szakok: {},
      szocpontParameterek: {},
      tamogatasok: [
        {"value":"Rendszeres_Szoc","text":"Rendszeres szociális támogatás és Lakhatási támogatás"}/*,{"value":"Laktam","text":"Lakhatási támogatás"}*/,{"value":"Kolts_Csokk","text":"Költségtérítés mérséklés"},{"value":"Kollegium","text":"Kollégium"}
      ],
      csaladi_allapot_fogyatekossag: [
        {"value":"Arva","text":"Árva","disabled":0},{"value":"Nagy_Csalados","text":"Nagycsaládos","disabled":0},{"value":"Gyermeke_Van","text":"Gyermeke van","disabled":0},{"value":"Apolasi_Dij","text":"Ápolási díjra jogosult","disabled":0},{"value":"Fogyatekos","text":"Fogyatékossággal élő","disabled":0},{"value":"Onfenntarto","text":"A pályázó önfenntartó","disabled":0},{"value":"Felarva","text":"Félárva","disabled":0},{"value":"Nagykoru","text":"Gyámsága nagykorúsága miatt szűnt meg","disabled":0},{"value":"Hatranyos","text":"Hátrányos helyzetű","disabled":0},{"value":"Kiemelkedoen_Hatranyos","text":"Kiemelkedően hátrányos helyzetű","disabled":0},{"value":"Eltarto_Egyedulallo","text":"A pályázó eltartója egyedülálló","disabled":0}
      ],
      elemleirasok: [],
      uj_betegseg: {
        BNOKod: '',
        BetegsegNeve: '',
        PalyazoBetegsege: true,
        CsaladtagNeve: '',
        CsaladtagRokonsagiFoka: ''
      },
      uj_jovedelem: {
        Nev: '',
        Rokonsagi_Fok: '',
        Tipus: 'Munkavallalo',
        Osszeg: '',
        Palyazo: false
      },
      betegsegek: {
        items: [],
        selected: 0
      },
      jovedelem_tipusok: [
        {value:'Munkavallalo',text:'Munkavállaló'},{value:'Vallalkozo',text:'Vállalkozó'},{value:'Segelyben_Nem_Reszesul',text:'Segélyben nem részesül'},{value:'Segelyben_Reszesul',text:'Segélyben részesül'},{value:'Haztartasbeli',text:'Háztartásbeli'},{value:'Rokkantnyugdijas',text:'Rokkantnyugdíjas'},{value:'Nyugdijas',text:'Nyugdíjas'},{value:'Kiskoru_Tanulo',text:'Kiskorú tanuló'},{value:'Egyeb',text:'Egyéb'}
      ],
      jovedelem_tipusok_kalk: [],
      jovedelem_osszeg_kalk: 0,
      jovedelem_osszeg_pont: 0,
      jovedelem_osszpont: 0,
      urlap_letoltheto: false
    }
  },

  mounted: function() {
  	var _this = this;

    Vue.nextTick(function() {
      _this.urlapKitoltheto();
      _this.setPanels();
      _this.getElemleirasok();

      $(window).scroll(function() {
        _this.setPanels();
      });
    });

  },
  watch: {
    'form.tamogatasok': function (newVal, oldVal) {
      if(jQuery.inArray('Rendszeres_Szoc',oldVal) == '-1' && jQuery.inArray('Rendszeres_Szoc',newVal) >= 0) {
        this.form.tamogatasok.push('Laktam');
      } else if(jQuery.inArray('Rendszeres_Szoc',oldVal) >= 0 && jQuery.inArray('Rendszeres_Szoc',newVal) == '-1') {
        this.form.tamogatasok = jQuery.grep(this.form.tamogatasok, function(value) {
          return value != 'Laktam';
        });
      }
      if(jQuery.inArray('Kolts_Csokk',newVal) == '-1') {
        this.form.TMDK = false;
        this.$refs.igazolasfeltolto.deleteBlock('TMDK');
        this.form.HallgSzervTev = false;
        this.$refs.igazolasfeltolto.deleteBlock('HallgSzervTev');
        this.form.EgyebTev = false;
        this.$refs.igazolasfeltolto.deleteBlock('EgyebTev');
      }
    }
  },
  methods: {
    urlapKitoltheto: function() {
      var _this = this;
      this.$root.ajax('hatar/urlap_kitoltheto/RendszeresSzocialisTamogatas/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            if (!response.kitoltheto) {
              _this.fill_info = 'Az űrlap nem tölthető ki.';

            } else {
              _this.$root.ajax('hatar/rendszeres_szocialis_tamogatas_visszatoltes/' + _this.$root.user.neptuncode, {
                method: 'GET',
                success: function(response) {
                  if (response.error) {
                    swal('Hiba!', response.error, 'error');
                  } else {
                    if (response.form != undefined && response.form != false) {
                      _this.form = response.form;
                      if (response.FeltoltottDokumentumStruktura != null)
                        _this.$refs.igazolasfeltolto.setFullData(JSON.parse(response.FeltoltottDokumentumStruktura));

                      if (response.PontszamStruktura != null)
                        _this.$refs.pontszam.setFullData(JSON.parse(response.PontszamStruktura));

                      _this.kalkJovedelemOsszeg();
                      _this.kalkJovedelemTipusok();
                      _this.jovedelmekPontKalkulacio();
                      _this.betegsegPontKalk();
                      _this.szembetegsegPontKalk();
                      _this.csaladiAllapotFogyatekossagVisszaallitas();
                    }
                  }
                }
              });
            }
          }
        }
      });
    },

    jovedelemUploaderBlokkModositas: function(jovedelem_id) {
      var _this = this;

      this.form.jovedelmek.map(function(j) {
        if (j.id == jovedelem_id)
          _this.$refs.igazolasfeltolto.modifyBlock(jovedelem_id, 'Jövedelem igazolás', j.Nev + ' (' + _this.jovedelemTipusMegnevezes(j.Tipus) + ') jövedelemigazolása');
      });
    },

    jovedelemTipusMegnevezes: function(tipus) {
      var text = '';
      this.jovedelem_tipusok.map(function(j) {
        if (j.value == tipus)
          text = j.text;
      });
      return text;
    },

    kalkJovedelemOsszeg: function() {
      var total = 0;
      this.form.jovedelmek.map(function(j) {
        if (j.Osszeg != '')
          total += parseInt(j.Osszeg);
      });
      this.jovedelem_osszeg_kalk = new Intl.NumberFormat('hu-HU', { minimumFractionDigits: 0 }).format(total);
    },

    kalkJovedelemTipusok: function() {
      var _this = this;
      var tipusok = [];

      this.jovedelem_tipusok.map(function(jt) {
        var db = 0;
        var pont = 0;

        _this.form.jovedelmek.map(function(j) {
          if (j.Tipus == jt.value) {
            db++;

            switch(j.Tipus) {
              case 'Segelyben_Nem_Reszesul':
                pont += parseInt(_this.szocpontParameterek.SzocpontSegelybenNemReszesul);
              break;
              case 'Rokkantnyugdijas':
                pont += parseInt(_this.szocpontParameterek.SzocpontRokkantnyugdijas);
              break;
              case 'Kiskoru_Tanulo':
                pont += parseInt(_this.szocpontParameterek.SzocpontKiskoruTanulo);
              break;
              case 'Kiskoru_Tanulo':
                pont += parseInt(_this.szocpontParameterek.SzocpontKiskoruTanulo);
              break;
            }
          }
        });

        if (db > 0)
          tipusok.push({
            cim: jt.text,
            db: db,
            pont: pont
          });
      });

      this.jovedelem_tipusok_kalk = tipusok;
    },

    jovedelemPalyazoChange: function(index) {
      if (this.form.jovedelmek[index].Palyazo) {
        this.uj_jovedelem.Palyazo = false;

        this.form.jovedelmek.map(function(jovedelem, j) {
          if (j != index)
            jovedelem.Palyazo = false;
        });
      }
    },

    ujJovedelemPalyazoChange: function() {
      var _this = this;

      this.form.jovedelmek.map(function(jovedelem) {
        if (jovedelem.Palyazo)
          _this.uj_jovedelem.Palyazo = false;
      });
    },

    getTooltipDescriptionByKey: function(tkey) {
      var desc = '';
      this.elemleirasok.map(function(el) {
        if (el.tkey == tkey)
          desc = el.tooltip_description;
      });

      return desc;
    },

    getPointDescriptionByKey: function(tkey) {
      var desc = '';
      this.elemleirasok.map(function(el) {
        if (el.tkey == tkey)
          desc = el.point_description;
      });

      return desc;
    },

    getUploadDescriptionByKey: function(tkey) {
      var desc = '';
      this.elemleirasok.map(function(el) {
        if (el.tkey == tkey)
          desc = el.upload_description;
      });

      return desc;
    },

    getElemleirasok: function() {
      var _this = this;
      this.$root.ajax('hatar/elemleirasok/RendszeresSzocialisTamogatas', {
        method: 'GET',
        success: function(response) {
          _this.elemleirasok = response.elemleirasok;
        }
      });
    },

    getBetegsegek: function() {
      var _this = this;
      this.$root.ajax('/hatar/betegsegek', {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.betegsegek = response.betegsegek;
          } else
            alert(response.error);
        }
      });
    },

    jovdelemTorles: function(id) {
      var _this = this;

      swal({
        title: "Biztos törli a jövedelmet?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.form.jovedelmek = _this.form.jovedelmek.filter(function( jovedelem ) {
              return jovedelem.id !== id;
          });
          _this.kalkJovedelemTipusok();
          _this.kalkJovedelemOsszeg();
          _this.jovedelmekPontKalkulacio();
          _this.$refs.igazolasfeltolto.deleteBlock(id);
        }
      });
    },

    jovedelemHozzaad: function() {
      if (this.uj_jovedelem.Osszeg == '') {
        this.errors.push({
          id: 'uj_jovedelem_osszeg',
          msg: 'Adjon meg összeget'
        });
        return false;
      }

      this.errors = [];

      var id = this.$root.guid();

      this.form.jovedelmek.push({
        id: id,
        Nev: this.uj_jovedelem.Nev,
        Rokonsagi_Fok: this.uj_jovedelem.Rokonsagi_Fok,
        Tipus: this.uj_jovedelem.Tipus,
        Osszeg: this.uj_jovedelem.Osszeg,
        Palyazo: this.uj_jovedelem.Palyazo
      });
      this.kalkJovedelemTipusok();
      this.kalkJovedelemOsszeg();
      this.jovedelmekPontKalkulacio();
      this.$refs.igazolasfeltolto.newBlock(id, 'Jövedelem igazolás', this.uj_jovedelem.Nev + ' (' + this.jovedelemTipusMegnevezes(this.uj_jovedelem.Tipus) + ') jövedelemigazolása');

      this.uj_jovedelem = {
        Nev: '',
        Rokonsagi_Fok: '',
        Tipus: 'Munkavallalo',
        Osszeg: '',
        Palyazo: false
      };
    },

    betegsegTorles: function(id) {
      var _this = this;

      swal({
        title: "Biztos törli a betegséget?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.form.betegsegek = _this.form.betegsegek.filter(function( betegseg ) {
              return betegseg.id !== id;
          });

          _this.$refs.igazolasfeltolto.deleteBlock(id);

          _this.betegsegPontKalk();
        }
      });
    },

    betegsegHozzaad: function() {
      var _this = this;
      var data = {};
      data.kod = this.betegsegek.selected;
      this.$root.ajax('hatar/betegseg', {
        method: 'POST',
        data: data,
        success: function(response) {
          if (response.error == false) {
            _this.uj_betegseg.BNOKod = _this.betegsegek.selected;
            _this.uj_betegseg.BetegsegNeve = response.betegseg.BetegsegNeve;

            var id = _this.$root.guid()
            var point = 0;
            if(_this.uj_betegseg.PalyazoBetegsege) {
              point = parseFloat(response.betegseg.PalyazoPont);
            } else {
              point = parseFloat(response.betegseg.CsaladPont);
            }
            _this.form.betegsegek.push({
              id: id,
              BNOKod: _this.uj_betegseg.BNOKod,
              BetegsegNeve: _this.uj_betegseg.BetegsegNeve,
              PalyazoBetegsege: _this.uj_betegseg.PalyazoBetegsege,
              CsaladtagNeve: _this.uj_betegseg.CsaladtagNeve,
              CsaladtagRokonsagiFoka: _this.uj_betegseg.CsaladtagRokonsagiFoka,
              pont: point
            });

            _this.$refs.igazolasfeltolto.newBlock(id,_this.uj_betegseg.BetegsegNeve,'Betegség igazolására szolgáló dokumentum.');
            _this.uj_betegseg = {
              BNOKod: '',
              BetegsegNeve: '',
              PalyazoBetegsege: true,
              CsaladtagNeve: '',
              CsaladtagRokonsagiFoka: ''
            };

            _this.betegsegPontKalk();

          } else
            alert(response.error);
        }
      });
    },

    betegsegPontKalk: function() {
      var palyazoBetegsegePont = 0;
      var csaladTagBetegsegePont = 0;

      this.form.betegsegek.map(function(betegseg) {
        if (betegseg.PalyazoBetegsege)
          palyazoBetegsegePont += parseInt(betegseg.pont);
        else
          csaladTagBetegsegePont += parseInt(betegseg.pont);
      });

      if (palyazoBetegsegePont > parseInt(this.szocpontParameterek.SzocpontPalyazoBetegsege))
        palyazoBetegsegePont = parseInt(this.szocpontParameterek.SzocpontPalyazoBetegsege);

      if (csaladTagBetegsegePont > parseInt(this.szocpontParameterek.SzocpontCsaladtagBetegsege))
        csaladTagBetegsegePont = parseInt(this.szocpontParameterek.SzocpontCsaladtagBetegsege);

      this.$refs.pontszam.removePoint('palyazoBetegsege');
      this.$refs.pontszam.removePoint('csaladTagBetegsegePont');

      if (palyazoBetegsegePont > 0)
        this.$refs.pontszam.addPoint('palyazoBetegsege', 'Pályázó betegsége(i) után járó pontszám', 'Maximálisan ' + this.szocpontParameterek.SzocpontPalyazoBetegsege + ' pont adható.', palyazoBetegsegePont);

      if (csaladTagBetegsegePont > 0)
        this.$refs.pontszam.addPoint('csaladTagBetegsegePont', 'Családtag(ok) betegsége(i) után járó pontszám', 'Maximálisan ' + this.szocpontParameterek.SzocpontCsaladtagBetegsege + ' pont adható.', csaladTagBetegsegePont);
    },

    setPanels: function() {
      var h = $('header').outerHeight() + $('.subpage-head-image').outerHeight() + $('.submenu').outerHeight() + 40 - 20;
      if ($(window).scrollTop() >= h) {
        $('.panels').addClass('fixed').css('width', $('.panels').parents('div').width());
      } else {
        $('.panels').removeClass('fixed').css('width', 'auto');
      }

      // Ha a lábléc megjelenik, akkor a magasságból ki kell vonni a látható lábléc magasságát
      if (($(window).scrollTop() + $(window).innerHeight()) >= $('footer').offset().top) {
        $('.panels').css({
          'max-height': $(window).innerHeight() - 40 - (($(window).scrollTop() + $(window).innerHeight()) - $('footer').offset().top)
        });
      } else {
        $('.panels').css({
          'max-height': $(window).innerHeight() - 40
        });
      }
    },

    fileBoxAndPointChange: function(id, title, point_description, upload_description, point, event, key) {
      if (point_description == '' && key != '') {
        point_description = this.getPointDescriptionByKey(key);
      }

      if (upload_description == '' && key != '') {
        upload_description = this.getUploadDescriptionByKey(key);
      }

      if(event.target.checked) {
        this.$refs.pontszam.addPoint(id, title, point_description, point);
        this.$refs.igazolasfeltolto.newBlock(id, title, upload_description);

      } else {
        this.$refs.pontszam.removePoint(id);
        this.$refs.igazolasfeltolto.deleteBlock(id);
      }

    },

    csaladiAllapotFogyatekossagVisszaallitas: function() {
      var _this = this;

      this.csaladiAllapotEsFogyatekossagPontKalk();

      this.csaladi_allapot_fogyatekossag.map(function(f) {
        if (_this.form.csaladi_allapot_fogyatekossag.indexOf(f.value) > -1) {
          switch(f.value) {
            case 'Arva':
              _this.csaladi_allapot_fogyatekossag.map(function(m) {
                if (m.value == 'Eltarto_Egyedulallo') {
                  m.disabled++;
                }
                if (m.value == 'Onfenntarto') {
                  m.disabled++;
                }
              });
            break;
            case 'Felarva':
              _this.csaladi_allapot_fogyatekossag.map(function(m) {
                if (m.value == 'Eltarto_Egyedulallo') {
                  m.disabled++;
                }
              });
            break;
            case 'Gyermeke_Van':
              _this.csaladi_allapot_fogyatekossag.map(function(m) {
                if (m.value == 'Onfenntarto') {
                  m.disabled++;
                }
              });
            break;
            case 'Apolasi_Dij':
              _this.csaladi_allapot_fogyatekossag.map(function(m) {
                if (m.value == 'Onfenntarto') {
                  m.disabled++;
                }
              });
            break;
            case 'Eltarto_Egyedulallo':
              _this.csaladi_allapot_fogyatekossag.map(function(m) {
                if (m.value == 'Felarva') {
                  m.disabled++;
                }
              });
            break;
            case 'Onfenntarto':
              _this.csaladi_allapot_fogyatekossag.map(function(m) {
                if (m.value == 'Arva') {
                  m.disabled++;
                }
                if (m.value == 'Felarva') {
                  m.disabled++;
                }
              });
            break;
          }
        }
      });
    },

    csaladiAllapotFogyatekossagElemUncheckEsTiltas: function(id, tiltas) {
      var _this = this;

      if (this.form.csaladi_allapot_fogyatekossag.indexOf(id) > -1) {
        this.form.csaladi_allapot_fogyatekossag = _this.form.csaladi_allapot_fogyatekossag.filter(function(item) {
            return item !== id;
        });

        this.$refs.igazolasfeltolto.deleteBlock('csaladi_allapot_fogyatekossag_'+id);

        switch(id) {
          case 'Arva':
            this.csaladi_allapot_fogyatekossag.map(function(m) {
              if (m.value == 'Eltarto_Egyedulallo' && m.disabled > 0) {
                m.disabled--;
              }
              if (m.value == 'Onfenntarto' && m.disabled > 0) {
                m.disabled--;
              }
            });
          break;

          case 'Felarva':
            this.csaladi_allapot_fogyatekossag.map(function(m) {
              if (m.value == 'Eltarto_Egyedulallo' && m.disabled > 0) {
                m.disabled--;
              }
            });
          break;

          case 'Gyermeke_Van':
            this.csaladi_allapot_fogyatekossag.map(function(m) {
              if (m.value == 'Onfenntarto' && m.disabled > 0) {
                m.disabled--;
              }
            });
          break;

          case 'Apolasi_Dij':
            this.csaladi_allapot_fogyatekossag.map(function(m) {
              if (m.value == 'Onfenntarto' && m.disabled > 0) {
                m.disabled--;
              }
            });
          break;

          case 'Eltarto_Egyedulallo':
            this.csaladi_allapot_fogyatekossag.map(function(m) {
              if (m.value == 'Felarva' && m.disabled > 0) {
                m.disabled--;
              }
            });
          break;

          case 'Onfenntarto':
            this.csaladi_allapot_fogyatekossag.map(function(m) {
              if (m.value == 'Arva' && m.disabled > 0) {
                m.disabled--;
              }
              if (m.value == 'Felarva' && m.disabled > 0) {
                m.disabled--;
              }
            });
          break;
        }
      }

      if (tiltas != undefined) {
        this.csaladi_allapot_fogyatekossag.map(function(m) {
          if (m.value == id)
            m.disabled++;
        });
      }
    },

    csaladiAllapotFogyatekossagElemTiltasMegszuntetes: function(id) {
      var _this = this;

      this.csaladi_allapot_fogyatekossag.map(function(m) {
        if (m.value == id && m.disabled > 0) {
          m.disabled--;
        }
      });

      switch(id) {
        case 'Arva':
          this.csaladi_allapot_fogyatekossag.map(function(m) {
            if (m.value == 'Eltarto_Egyedulallo' && m.disabled > 0) {
              m.disabled--;
            }
            if (m.value == 'Onfenntarto' && m.disabled > 0) {
              m.disabled--;
            }
            if (m.value == 'Felarva' && m.disabled > 0) {
              m.disabled--;
            }
          });
        break;

        case 'Felarva':
          this.csaladi_allapot_fogyatekossag.map(function(m) {
            if (m.value == 'Eltarto_Egyedulallo' && m.disabled > 0) {
              m.disabled--;
            }
          });
        break;

        case 'Gyermeke_Van':
          this.csaladi_allapot_fogyatekossag.map(function(m) {
            if (m.value == 'Onfenntarto' && m.disabled > 0) {
              m.disabled--;
            }
            if (m.value == 'Arva' && m.disabled > 0) {
              m.disabled--;
            }
            if (m.value == 'Felarva' && m.disabled > 0) {
              m.disabled--;
            }
          });
        break;

        case 'Apolasi_Dij':
          this.csaladi_allapot_fogyatekossag.map(function(m) {
            if (m.value == 'Onfenntarto' && m.disabled > 0) {
              m.disabled--;
            }
            if (m.value == 'Felarva' && m.disabled > 0) {
              m.disabled--;
            }
            if (m.value == 'Arva' && m.disabled > 0) {
              m.disabled--;
            }
          });
        break;

        case 'Eltarto_Egyedulallo':
          this.csaladi_allapot_fogyatekossag.map(function(m) {
            if (m.value == 'Felarva' && m.disabled > 0) {
              m.disabled--;
            }
          });
        break;

        case 'Onfenntarto':
          this.csaladi_allapot_fogyatekossag.map(function(m) {
            if (m.value == 'Felarva' && m.disabled > 0) {
              m.disabled--;
            }
            if (m.value == 'Arva' && m.disabled > 0) {
              m.disabled--;
            }
          });
        break;
      }
    },

    csaladiAllapotFogyatekossagChange: function(id, title, point_description, upload_description, point, event, key) {
      var _this = this;

      if (point_description == '' && key != '') {
        point_description = this.getPointDescriptionByKey(key);
      }

      if (upload_description == '' && key != '') {
        upload_description = this.getUploadDescriptionByKey(key);
      }

      if (event.target.checked) {
        this.$refs.igazolasfeltolto.newBlock(id, title, upload_description);
      } else {
        this.$refs.igazolasfeltolto.deleteBlock(id);
      }

      if (key == 'Arva') {
        if (event.target.checked) {
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Felarva');
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Eltarto_Egyedulallo', 1);
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Onfenntarto', 1);

        } else {
          this.csaladiAllapotFogyatekossagElemTiltasMegszuntetes('Eltarto_Egyedulallo');
          this.csaladiAllapotFogyatekossagElemTiltasMegszuntetes('Onfenntarto');
        }
      }

      if (key == 'Felarva') {
        if (event.target.checked) {
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Arva');
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Eltarto_Egyedulallo', 1);
        } else {
          this.csaladiAllapotFogyatekossagElemTiltasMegszuntetes('Eltarto_Egyedulallo');
        }
      }

      if (key == 'Apolasi_Dij') {
        if (event.target.checked) {
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Onfenntarto', 1);
        } else {
          this.csaladiAllapotFogyatekossagElemTiltasMegszuntetes('Onfenntarto');
        }
      }

      if (key == 'Gyermeke_Van') {
        if (event.target.checked) {
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Onfenntarto', 1);
        } else {
          this.csaladiAllapotFogyatekossagElemTiltasMegszuntetes('Onfenntarto');
        }
      }

      if (key == 'Hatranyos') {
        if (event.target.checked) {
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Kiemelkedoen_Hatranyos');
        }
      }

      if (key == 'Kiemelkedoen_Hatranyos') {
        if (event.target.checked) {
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Hatranyos');
        }
      }

      if (key == 'Eltarto_Egyedulallo') {
        if (event.target.checked) {
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Onfenntarto');
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Felarva', 1);
        } else {
          this.csaladiAllapotFogyatekossagElemTiltasMegszuntetes('Felarva');
        }
      }

      if (key == 'Onfenntarto') {
        if (event.target.checked) {
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Eltarto_Egyedulallo');
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Arva', 1);
          this.csaladiAllapotFogyatekossagElemUncheckEsTiltas('Felarva', 1);
        } else {
          this.csaladiAllapotFogyatekossagElemTiltasMegszuntetes('Arva');
          this.csaladiAllapotFogyatekossagElemTiltasMegszuntetes('Felarva');
        }
      }

      // Ha disabled a mező, akkor kiszedi a checkboxot
      this.csaladi_allapot_fogyatekossag.map(function(m) {
        if (m.disabled > 0) {
          _this.form.csaladi_allapot_fogyatekossag = _this.form.csaladi_allapot_fogyatekossag.filter(function(item) {
              return item !== m.value;
          });
          _this.$refs.igazolasfeltolto.deleteBlock('csaladi_allapot_fogyatekossag_'+m.value);
        }
      });

      this.csaladiAllapotEsFogyatekossagPontKalk();
    },

    csaladiAllapotEsFogyatekossagPontKalk: function() {
      var pont = 0;

      this.$refs.pontszam.removePoint('csaladi_allapot_fogyatekossag');

      if (this.form.csaladi_allapot_fogyatekossag.indexOf('Arva') > -1 ||
          this.form.csaladi_allapot_fogyatekossag.indexOf('Nagy_Csalados') > -1 ||
          this.form.csaladi_allapot_fogyatekossag.indexOf('Kiemelkedoen_Hatranyos') > -1 ||
          this.form.csaladi_allapot_fogyatekossag.indexOf('Fogyatekos') > -1 ||
          this.form.csaladi_allapot_fogyatekossag.indexOf('Gyermeke_Van') > -1 ||
          this.form.csaladi_allapot_fogyatekossag.indexOf('Apolasi_Dij') > -1) {

        pont = this.szocpontParameterek.SzocPontHatranyos1;

      } else if (this.form.csaladi_allapot_fogyatekossag.indexOf('Felarva') > -1 ||
                 this.form.csaladi_allapot_fogyatekossag.indexOf('Nagykoru') > -1 ||
                 this.form.csaladi_allapot_fogyatekossag.indexOf('Hatranyos') > -1) {

        pont = this.szocpontParameterek.SzocPontHatranyos2;

      } else {
        if (this.form.csaladi_allapot_fogyatekossag.indexOf('Onfenntarto') > -1) {
          pont = this.szocpontParameterek.SzocpontOnfenntarto;

        } else if (this.form.csaladi_allapot_fogyatekossag.indexOf('Eltarto_Egyedulallo') > -1) {
          pont = this.szocpontParameterek.SzocpontEltartoEgyedul;
        }
      }

      if (pont > 0)
        this.$refs.pontszam.addPoint('csaladi_allapot_fogyatekossag', 'Családi állapot és fogyatékosság', 'Családi állapot és fogyatékosság után járó pontszám', pont);
    },

    fileBoxChange: function(id, title, upload_description, event, key) {
      if (upload_description == '' && key != '') {
        upload_description = this.getUploadDescriptionByKey(key);
      }

      if(event.target.checked) {
        this.$refs.igazolasfeltolto.newBlock(id, title, upload_description);
      } else {
        this.$refs.igazolasfeltolto.deleteBlock(id);
      }
    },

    save: function(veglegesit) {
      var _this = this;

      this.errors = [];

      _this.save_enabled = false;

      this.$root.ajax('hatar/ment/rendszeres_szocialis_tamogatas/', {
        method: 'POST',
        data: {
          form: this.form,
          all_files_uploaded: this.$refs.igazolasfeltolto.isAllFilesUpload(),
          blocks: this.$refs.igazolasfeltolto.getData(),
          hallgID: this.hallgato.HallgID,
          Neptunkod: this.hallgato.neptuncode,
          pontszamok: this.$refs.pontszam.getData(),
          veglegesit: veglegesit
        },
        success: function(response) {
          _this.save_enabled = true;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
            _this.hatarUrlapKitoltve();
          }
        }
      });
    },

    hatarUrlapKitoltve: function() {
      var _this = this;

      this.$root.ajax('hatar/urlap_kitoltve/RendszeresSzocialisTamogatas/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.urlap_letoltheto = response.kitoltve;
          } else
            swal('Hiba!',response.error,'error');
        }
      });
    },

    rendszeresSzocialisTamogatasPdf: function() {
      var _this = this;
      this.$root.ajax('hatar/rendszeres_szocialis_tamogatas_pdf/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            window.open('assets/urlap_kitoltesek/' + response.filename + '?' + Math.random(100000));
          } else {
            swal('Hiba!',response.error,'error');
          }
        }
      });
    },

    tavolsagpontKalk: function() {
      var p;
      var tavolsag = this.hallgato.distance_ovar;
      var leiras_kieg = '';

      if (tavolsag < 11) {
        p = 0;

      } else if (tavolsag >= 11 && tavolsag <= 60) {
        p = 1;
        leiras_kieg = '11-60 Km';

      } else if (tavolsag > 60 && tavolsag <= 110) {
        p = 2;
        leiras_kieg = '61-110 Km';

      } else if (tavolsag > 110 && tavolsag <= 160) {
        p = 3;
        leiras_kieg = '110-160 Km';

      } else if (tavolsag > 160 && tavolsag <= 210) {
        p = 4;
        leiras_kieg = '161-210 Km';

      } else if (tavolsag > 210 && tavolsag <= 260) {
        p = 5;
        leiras_kieg = '211-260 Km';

      } else if (tavolsag > 260) {
        p = 6;
        leiras_kieg = '261 Km-nél távolabb';
      }

      if (p != 0)
        this.$refs.pontszam.addPoint('tavolsag', 'Távolság', 'Hallgató lakóhelyének távolsága a képzés helyszínétől (' + leiras_kieg + ')', p);
    },

    szembetegsegPontKalk: function() {
      var p = 0;
      var bd = this.form.BalDioptria == '' ? 0 : parseFloat(this.form.BalDioptria);
      var jd = this.form.JobbDioptria == '' ? 0 : parseFloat(this.form.JobbDioptria);

      var max = Math.max(bd, jd);

      if (max >= 1 && max <= 1.49) {
        p = 1;

      } else if (max >= 1.5 && max <= 1.99) {
        p = 2;

      } else if (max >= 2 && max <= 2.49) {
        p = 3;

      } else if (max >= 2.5 && max <= 2.99) {
        p = 4;

      } else if (max >= 3) {
        p = 5;
      }

      this.$refs.igazolasfeltolto.deleteBlock('szembetegseg_dioptria');
      this.$refs.pontszam.removePoint('szembetegseg_dioptria');

      if (p != 0) {
        this.$refs.igazolasfeltolto.newBlock('szembetegseg_dioptria', 'Szembetegség', 'Pályázó szembetegségét (' + max + ' dioptria) igazoló dokumentum');
        this.$refs.pontszam.addPoint('szembetegseg_dioptria', 'Szembetegség', 'Pályázó szembetegsége (' + max + ' dioptria) után adható pontszám', p);
      }
    },

    jovedelmekPontKalkulacio: function() {
      var JovedelemMaxHaztartasra = 0;
      var JovedelemArany = 0;
      var Jovedelem = 0;
      var p = 0;
      var p_ = 0;

      // Jövedelem típus szerinti pont összesítés
      this.jovedelem_tipusok_kalk.map(function(jt) {
        p_ += parseInt(jt.pont);
      });

      // Jövedelem összeg szerinti pont összesítés
      this.form.jovedelmek.map(function(j) {
        if (j.Osszeg != '')
          Jovedelem += parseInt(j.Osszeg);
      });

      if (Jovedelem == 0) {
        p = 0;

      } else {
        if (this.form.jovedelmek.length == 1) {
          JovedelemMaxHaztartasra = parseInt(this.szocpontParameterek.SzocKerelem_JovMinimalBer);

        } else if (this.form.jovedelmek.length > 7) {
          JovedelemMaxHaztartasra = parseInt(this.szocpontParameterek.SzocKerelem_JovMinimalBer) * parseFloat(this.szocpontParameterek.SzocKerelem_JovSzorzok[5]);

        } else {
          JovedelemMaxHaztartasra = parseInt(this.szocpontParameterek.SzocKerelem_JovMinimalBer) * parseFloat(this.szocpontParameterek.SzocKerelem_JovSzorzok[this.form.jovedelmek.length - 2]);
        }

        JovedelemArany = Jovedelem / JovedelemMaxHaztartasra;

        if (JovedelemArany > 1) {
          p = 0;

        } else {
          var i = 0;

          for (var i = 0; i < 7 && JovedelemArany < parseFloat(this.szocpontParameterek.SzocKerelem_JovKatHatarok[i]); i++) {
            p = parseInt(this.szocpontParameterek.SzocKerelem_JovEgyForeJutoPont[i]);
          }
        }
      }

      this.jovedelem_osszeg_pont = p;

      // Jövedelem összeg, és jövedelem típus összpontszám
      this.jovedelem_osszpont = p + p_;

      if (this.jovedelem_osszpont > this.szocpontParameterek.SzocPontHaztartas)
        this.jovedelem_osszpont = this.szocpontParameterek.SzocPontHaztartas;

      if (this.jovedelem_osszpont != 0) {
        this.$refs.pontszam.removePoint('jovedelmek');
        this.$refs.pontszam.addPoint('jovedelmek', 'Jövedelmek', 'A pályázóval közös háztartásban élők előző havi nettó jövedelme alapján számított pontszám. Maximálisan ' + this.szocpontParameterek.SzocPontHaztartas + ' pontszám adható.', this.jovedelem_osszpont);
      } else {
        this.$refs.pontszam.removePoint('jovedelmek');
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// rendszeres_szocialis_tamogatas.vue?341d1f69